import useGetWidth from './useGetWidth';

//* Must be equal to $breakpoint-width-mobile in scss/mixins/mixins.scss
const breakpoints = {
  mobile: 1024,
};

const useResponsive = () => {
  const width = useGetWidth();

  const isMobile = width <= breakpoints.mobile;
  const isDesktop = width > breakpoints.mobile;

  return {
    isMobile,
    isDesktop,
  };
};

export default useResponsive;
